import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../../services/api";
import ItemForm from "./ItemForm";
import { saveAs } from "file-saver";
import { format } from "date-fns";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import "bootstrap/dist/css/bootstrap.min.css";

const ItemList = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  
  useEffect(() => {
    fetchItems();
  }, [page, pageSize, searchQuery]);

  const fetchItems = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`/items?page=${page}&limit=${pageSize}&search=${searchQuery}`);
      
      console.log("API Response:", response.data); // ✅ Debug API response
  
      setItems(response.data.items);
      setTotalPages(response.data.totalPages);
    } catch (error) {
      console.error("Error fetching items:", error);
    }
    setLoading(false);
  };
  

  const handleEdit = (item) => {
    setEditItem(item);
    setShowForm(true);
  };

  const handleDisable = async (id) => {
    console.log("Disable Function Called with ID:", id);
    
    if (!id) {
      alert("Error: Item ID is undefined.");
      return;
    }
  
    if (window.confirm("Are you sure you want to disable this item?")) {
      try {
        await axios.put(`/items/${id}/disable`); // ✅ Match backend route
        fetchItems();
      } catch (error) {
        console.error("Error disabling item:", error.response ? error.response.data : error);
      }
    }
  };
  
  const handleEnable = async (id) => {
    if (!id) {
      console.error("Error: Item ID is undefined", id);
      return;
    }
  
    if (window.confirm("Are you sure you want to enable this item?")) {
      try {
        await axios.put(`/items/${id}/enable`);
        fetchItems();
      } catch (error) {
        console.error("Error enabling item:", error);
      }
    }
  };

  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(items);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Items");
    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8" });
    saveAs(data, "items.xlsx");
  };

  
  

  return (
    <div className="container mt-4">
      <h2 className="mb-3">Items</h2>

      <button onClick={() => { setEditItem(null); setShowForm(true); }} className="btn btn-primary mb-3">
        + Add Item
      </button>
      <div className="row mb-3 align-items-center">
  {/* Show Entries Dropdown */}
  <div className="col-md-4">
    <select className="form-select" value={pageSize} onChange={(e) => setPageSize(Number(e.target.value))}>
      <option value="10">Show 10</option>
      <option value="50">Show 50</option>
      <option value="100">Show 100</option>
    </select>
  </div>

  {/* Search Bar */}
  <div className="col-md-4">
    <input
      type="text"
      placeholder="Search items..."
      className="form-control"
      value={searchQuery}
      onChange={(e) => setSearchQuery(e.target.value)}
    />
  </div>

  {/* Export to Excel Button */}
  <div className="col-md-4 text-md-end">
    <button onClick={exportToExcel} className="btn btn-success">Export Excel</button>
  </div>
</div>

      {showForm && <ItemForm fetchItems={fetchItems} editItem={editItem} closeModal={() => setShowForm(false)} />}

      {loading ? (
        <p>Loading items...</p>
      ) : (
        <div className="table-responsive">
          <table className="table table-hover shadow-sm">
          <thead className="thead-dark">
  <tr>
    <th>Sr No</th>
    <th>Name</th>
    <th>Category</th>
    <th>Unit</th>
    <th>Added Date</th>
    <th>Status</th>  {/* ✅ New Column */}
    <th>Actions</th>
  </tr>
</thead>
<tbody>
  {items.map((item, index) => {
    console.log("Item in Table:", item); // ✅ Debug each row item

    return (
      <tr key={item.id || index}>
        <td>{(page - 1) * pageSize + index + 1}</td>
        <td>{item.name}</td>
        <td>{item.category}</td>
        <td>{item.unit}</td>
        <td>{item.created_at}</td>
        <td>
          {item.status === 1 ? (
            <span className="badge bg-success">Enabled</span>
          ) : (
            <span className="badge bg-danger">Disabled</span>
          )}
        </td>
        <td>
          <button onClick={() => handleEdit(item)} className="btn btn-warning btn-sm me-2">✏️ Edit</button>
          {item.status === 1 ? (
            <button onClick={() => handleDisable(item.id)} className="btn btn-secondary btn-sm">
              🚫 Disable
            </button>
          ) : (
            <button onClick={() => handleEnable(item.id)} className="btn btn-success btn-sm">
              ✅ Enable
            </button>
          )}
        </td>
      </tr>
    );
  })}
</tbody>


          </table>
          <div className="d-flex justify-content-between mt-3">
            <button onClick={() => setPage((prev) => Math.max(prev - 1, 1))} disabled={page === 1} className="btn btn-secondary">
              Previous
            </button>
            <span> Page {page} of {totalPages} </span>
            <button onClick={() => setPage((prev) => Math.min(prev + 1, totalPages))} disabled={page === totalPages} className="btn btn-secondary">
              Next
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ItemList;